/**
 * Custom Filters - Sale Collection
 * Template-specific configuration for sale/discount collections
 *
 * Requires: custom-filters-core.js to be loaded first
 */

document.addEventListener('DOMContentLoaded', function() {
  // The API's discount collection is a fixed slug — no handle mapping needed.
  window.CustomFilters.init({
    type: 'sale',
    collectionHandle: 'sale',
    collectionSlug: 'on-sale',
    excludedFilters: ['subcategories', 'locations', 'trends', 'motorTypes'],
  });
});
